// CategorySlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchCategories } from '../../services/productService';

const CategorySlice = createSlice({
    name: 'categories',
    initialState: {
        categories: [],
        loader : false
    },
    reducers: {
    },
    extraReducers : (builder) => {
        builder
        .addCase(fetchCategories.pending, (state) => {
            state.loader = true
        })
        .addCase(fetchCategories.rejected, (state, action) => {
            state.loader = false;
        })
        .addCase(fetchCategories.fulfilled, (state, action) => {
            state.loader = false;
            state.categories = action.payload;
            
        })
    }
});

export const {} = CategorySlice.actions;
export default CategorySlice.reducer;
